/**
 * ============================================================================
 * TRANSIENT: Appointment Config Page (appointment-config-page)
 * Type: poc
 * Amplitude key: none
 * End date: 2026-12-31
 * PR: #TODO_AFTER_PR_CREATION_appointment-config-page
 * ============================================================================
 */

import { Box, Button, Chip, Stack, Typography } from '@evaneos/b2b-ui';
import CircleIcon from '@evaneos/b2b-ui/icons/Circle';

import { useDisconnectCalendarMutation } from '../../../resources/appointment/mutations';

export const AppointmentGoogleConnectionPartial = (): JSX.Element => {
    const { mutate: disconnect, isPending } = useDisconnectCalendarMutation();

    return (
        <Stack data-spec-id="agenda-section-google-connection" spacing={3}>
            <Box>
                <Typography variant="h3" sx={{ fontWeight: 700, fontSize: 20, mb: 0.5 }}>
                    {/* @todo translate: agenda.google_connection.title */}
                    Connexion à Google Calendar
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {/* @todo translate: agenda.google_connection.description */}
                    Gérez la synchronisation entre votre calendrier Google et Request Manager.
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Chip
                    data-spec-id="agenda-google-connected-status"
                    icon={
                        <CircleIcon sx={{ fontSize: '10px !important', color: 'success.main' }} />
                    }
                    label="Google Calendar connecté"
                    variant="outlined"
                    size="small"
                />
                <Button
                    data-spec-id="agenda-google-disconnect-btn"
                    variant="outlined"
                    color="error"
                    size="small"
                    disabled={isPending}
                    onClick={() => disconnect('google')}
                >
                    {/* @todo translate: agenda.google_connection.disconnect */}
                    {isPending ? 'Déconnexion…' : 'Déconnecter'}
                </Button>
            </Box>
        </Stack>
    );
};
